<section>
    <ol class="breadcrumb">
        <li class="breadcrumb-item">Home</li>
        <li class="breadcrumb-item">Vendors</li>
        <li class="breadcrumb-item active">Vendor Onboard Approval Search</li>
    </ol>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card" style="background-color: #007bff;">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header" style="color: white;"><i class="fas fa-search mr-1"></i>
                            Vendor Onboard Approval Search </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <button [ngClass]="showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                            <button [ngClass]="showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"
                                pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                                [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                        </div>
                        <div class="col-md-8">

                            <button *ngIf="sharedService.checkPermission('User_Export')" pButton label="Export"
                                class="p-button-raised  m-2" icon="pi pi-file-excel" type="button"
                                style="float: right;height: 30px;" (click)="exportVendorOnboardApprovalList()"></button>

                            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
                                (click)="clearFilter(dt2)" style="float: right;height: 30px;"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
    </p-confirmDialog>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-table-card-header" *ngIf="showToggle">
                    <div class="row">
                        <div class="col-md-6">

                        </div>
                        <div class="col-md-6">
                            <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns"
                                maxSelectedLabels="0" dropdownIcon="pi pi-list"
                                selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader]="false"
                                [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                                <ng-template let-column pTemplate="item">
                                    <div class="column-item">
                                        <div>{{column.header}}</div>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </div>
                    </div>
                </div>
                <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                    <p-table #dt2 [value]="vendorOnboardApprovalList" dataKey="id" [rows]="10" [sortOrder]="0" [lazy]="true"
                        (onLazyLoad)="loadVendorOnboardApprovalList($event)" paginatorDropdownAppendTo="body"
                        [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="350px" [resizableColumns]="true" columnResizeMode="expand"
                        [rowsPerPageOptions]="[10,25,50,100,250,500,1000]" [loading]="loading" styleClass="p-datatable-gridlines"
                        [paginator]="isshowpaginator" [totalRecords]="totalRecords" [responsive]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [globalFilterFields]="['vendorName', 'statusName', 'isMSATemplateAvailable', 'isPOTemplateAvailable', 'isNCATemplateAvailable', 'isEmailSent', 'createdByName', 'createdOn', 'modifiedByName', 'modifiedOn', 'submittedByEmail', 'vendorSubmittedOn']" [style]="{'width':'100%'}">
                        <ng-template pTemplate="colgroup" let-columns>
                            <colgroup [attr.colspan]="selectedColumns.length">
                                <col style="width: 4rem" *ngIf="isShowColumns('action')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorName')">
                                <col [ngStyle]="{'width':setColumnWidth(10)}" *ngIf="isShowColumns('statusName')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('msaType')">
                                <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isMSATemplateAvailable')">
                                <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isPOTemplateAvailable')">
                                <col [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isNCATemplateAvailable')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('insuranceExhibitId')">
                                <col [ngStyle]="{'width':setColumnWidth(7)}" *ngIf="isShowColumns('isEmailSent')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdByName')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdOn')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('submittedByEmail')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorSubmittedOn')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedByName')">
                                <col [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedOn')">
       
                            </colgroup>
                        </ng-template>

                        <ng-template pTemplate="header">
                            <tr>
                                <th pResizableColumn style="width: 4rem"
                                    *ngIf="isShowColumns('action') && sharedService.checkPermission('Admin_Add')">Action</th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorName')">Vendor<span
                                        pSortableColumn="vendorName" *ngIf="showSorting">
                                        <p-sortIcon field="vendorName"></p-sortIcon>
                                    </span>
                            
                                    <app-basic-filter [hidden]="!showFilters" [field]="'vendorName'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-basic-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(10)}" *ngIf="isShowColumns('statusName')">
                                    Status <span pSortableColumn="statusName" *ngIf="showSorting">
                                        <p-sortIcon field="statusName"></p-sortIcon>
                                    </span>
                            
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'statusName'" [values]="allVendorOnboardApprovalStatus"
                                        [optionLabel]="'description'" [optionValue]="'lookupOrder'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('msaType')">
                                    Employment Type <span pSortableColumn="msaType" *ngIf="showSorting">
                                        <p-sortIcon field="msaType"></p-sortIcon>
                                    </span>
                            
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'msaType'" [values]="allMSAType"
                                        [optionLabel]="'description'" [optionValue]="'description'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isMSATemplateAvailable')">MSA
                                    <span
                                        pSortableColumn="isMSATemplateAvailable" *ngIf="showSorting">
                                        <p-sortIcon field="isMSATemplateAvailable"></p-sortIcon>
                                    </span>
                            
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'isMSATemplateAvailable'"
                                        [values]="documentTemplateSearchValues" [optionLabel]="'description'" [optionValue]="'id'"
                                        [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isPOTemplateAvailable')">PO
                                    <span
                                    pSortableColumn="isPOTemplateAvailable" *ngIf="showSorting">
                                    <p-sortIcon field="isPOTemplateAvailable"></p-sortIcon>
                                </span>
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'isPOTemplateAvailable'"
                                        [values]="documentTemplateSearchValues" [optionLabel]="'description'" [optionValue]="'id'"
                                        [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isNCATemplateAvailable')">NCA
                                    <span
                                    pSortableColumn="isNCATemplateAvailable" *ngIf="showSorting">
                                    <p-sortIcon field="isNCATemplateAvailable"></p-sortIcon>
                                </span>
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'isNCATemplateAvailable'"
                                        [values]="documentTemplateSearchValues" [optionLabel]="'description'" [optionValue]="'id'"
                                        [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('insuranceExhibitId')">Insurance Exhibit A
                                    <!-- <span
                                    pSortableColumn="isInsuranceExhibit" *ngIf="showSorting">
                                    <p-sortIcon field="isInsuranceExhibit"></p-sortIcon>
                                </span>
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'isInsuranceExhibit'"
                                        [values]="documentTemplateSearchValues" [optionLabel]="'description'" [optionValue]="'id'"
                                        [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()"></app-dropdown-filter> -->
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(7)}" *ngIf="isShowColumns('isEmailSent')">Is Email Sent
                                    <span
                                    pSortableColumn="isEmailSent" *ngIf="showSorting">
                                    <p-sortIcon field="isEmailSent"></p-sortIcon>
                                </span>
                                    <app-dropdown-filter [hidden]="!showFilters" [field]="'isEmailSent'"
                                        [values]="documentTemplateSearchValues" [optionLabel]="'description'" [optionValue]="'id'"
                                        [filters]="filters" [table]="table" (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            
                                </th>
                            
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdByName')">Created By <span
                                        pSortableColumn="createdByName" *ngIf="showSorting">
                                        <p-sortIcon field="createdByName"></p-sortIcon>
                                    </span>
                            
                                    <app-basic-filter [hidden]="!showFilters" [field]="'createdByName'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-basic-filter>
                            
                                </th>
                             
                            
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdOn')">Created On <span
                                        pSortableColumn="createdOn" *ngIf="showSorting">
                                        <p-sortIcon field="createdOn"></p-sortIcon>
                                    </span>
                            
                                    <app-date-filter [hidden]="!showFilters" [field]="'createdOn'" [filters]="filters" [table]="table"
                                        (filterDate)="createdOnFilterData($event)" [filterData]="createdOnFilterValue"></app-date-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('submittedByEmail')">Submitted By
                                    <span pSortableColumn="submittedByEmail" *ngIf="showSorting">
                                        <p-sortIcon field="submittedByEmail"></p-sortIcon>
                                    </span>
                            
                                    <app-basic-filter [hidden]="!showFilters" [field]="'submittedByEmail'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-basic-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorSubmittedOn')">Submitted On
                                    <span pSortableColumn="vendorSubmittedOn" *ngIf="showSorting">
                                        <p-sortIcon field="vendorSubmittedOn"></p-sortIcon>
                                    </span>
                            
                                    <app-date-filter [hidden]="!showFilters" [field]="'vendorSubmittedOn'" [filters]="filters" [table]="table"
                                        (filterDate)="submittedOnFilterData($event)" [filterData]="submittedOnFilterValue"></app-date-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedByName')">Modified By
                                    <span pSortableColumn="modifiedByName" *ngIf="showSorting">
                                        <p-sortIcon field="modifiedByName"></p-sortIcon>
                                    </span>
                            
                                    <app-basic-filter [hidden]="!showFilters" [field]="'modifiedByName'" [filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-basic-filter>
                            
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedOn')">Modified On <span
                                        pSortableColumn="modifiedOn" *ngIf="showSorting">
                                        <p-sortIcon field="modifiedOn"></p-sortIcon>
                                    </span>
                            
                                    <app-date-filter [hidden]="!showFilters" [field]="'modifiedOn'" [filters]="filters" [table]="table"
                                        (filterDate)="modifiedOnFilterData($event)" [filterData]="modifiedOnFilterValue"></app-date-filter>
                            
                                </th>
                            
   
                            
                            </tr>
                            <tr [hidden]="!showFilters">
                                <th *ngIf="isShowColumns('action') && sharedService.checkPermission('Admin_Add')"></th>
                                <th *ngIf="isShowColumns('vendorName')">{{filters?.vendorName[0]?.value}}</th>
                                <th *ngIf="isShowColumns('statusName')">{{selectedVendorOnboardApprovalStatus}}</th>
                                <th *ngIf="isShowColumns('msaType')">{{selectedMSAType}}</th>
                                <th *ngIf="isShowColumns('isMSATemplateAvailable')">{{selectedMSATemplateStatus}}</th>
                                <th *ngIf="isShowColumns('isPOTemplateAvailable')">{{selectedPOTemplateStatus}}</th>
                                <th *ngIf="isShowColumns('isNCATemplateAvailable')">{{selectedNCATemplateStatus}}</th>
                                <th *ngIf="isShowColumns('insuranceExhibitId')"></th>
                                <th *ngIf="isShowColumns('isEmailSent')">{{selectedIsEmailSentStatus}}</th>
                                <th *ngIf="isShowColumns('createdByName')">{{filters?.createdByName[0]?.value}}</th>
                            
                                <th *ngIf="isShowColumns('createdOn')">
                                    <div *ngIf="createdOnFilterValue != undefined">
                                        {{createdOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span
                                            *ngIf="createdOnFilterValue.length > 1">-</span> {{createdOnFilterValue[1]?.valueControl |
                                        date:'MM/dd/yyyy'}}
                                    </div>
                                </th>
                                <th *ngIf="isShowColumns('submittedByEmail')">{{filters?.submittedByEmail[0]?.value}}</th>
                            
                                <th *ngIf="isShowColumns('vendorSubmittedOn')">
                                    <div *ngIf="submittedOnFilterValue != undefined">
                                        {{submittedOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span
                                            *ngIf="submittedOnFilterValue.length > 1">-</span> {{submittedOnFilterValue[1]?.valueControl |
                                        date:'MM/dd/yyyy'}}
                                    </div>
                                </th>
                                <th *ngIf="isShowColumns('modifiedByName')">{{filters?.modifiedByName[0]?.value}}</th>
                            
                                <th *ngIf="isShowColumns('modifiedOn')">
                                    <div *ngIf="modifiedOnFilterValue != undefined">
                                        {{modifiedOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span
                                            *ngIf="modifiedOnFilterValue.length > 1">-</span> {{modifiedOnFilterValue[1]?.valueControl |
                                        date:'MM/dd/yyyy'}}
                                    </div>
                                </th>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-vendorOnboardApprovalList>
                            <tr>
                                <td style="width: 4rem"
                                    *ngIf="isShowColumns('action')">
                                    <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v" (click)="selectedGridMenuItem = vendorOnboardApprovalList;getMenu(vendorOnboardApprovalList); 
                                                                                                    menu.toggle($event)"></i></a>
                                    <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                </td>
                             
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorName')">
                                    <span>{{vendorOnboardApprovalList.vendorName}}</span>
                                </td>
                        
                                <td [ngStyle]="{'width':setColumnWidth(10)}" *ngIf="isShowColumns('statusName')">
                                    <span class="customer-badge status-checklists-pending"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Pending Approval')">Pending Approval</span>
                                    <span class="customer-badge status-interview-completed"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Template Modified')">Template Modified</span>
                                    <span class="customer-badge status-not-selected"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Template Rejected')">Template Rejected</span>
                                    <span class="customer-badge status-offer-accepted"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Email Initiated')">Email Initiated</span>
                                    <span class="customer-badge status-forwarded"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Submitted By Vendor')">Submitted By Vendor</span>
                                    <span class="customer-badge status-interview"
                                        *ngIf="(vendorOnboardApprovalList.statusName==='Vendor Onboarded')">Vendor Onboarded</span>
                                    <span class="customer-badge status-withdrawn-offer"
                                            *ngIf="(vendorOnboardApprovalList.statusName==='Submitted By Applicant')">Submitted By Applicant</span>
                                    <span class="customer-badge status-joined"
                                            *ngIf="(vendorOnboardApprovalList.statusName==='Vendor Link Reinitiated')">Vendor Link Reinitiated</span>
                                    <span class="customer-badge status-offer-accepted"
                                            *ngIf="(vendorOnboardApprovalList.statusName==='NCA Link Reinitiated')">NCA Link Reinitiated</span>
                                    <span class="customer-badge status-interview"
                                            *ngIf="(vendorOnboardApprovalList.statusName==='Completed')">Completed</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('msaType')">
                                    <span>{{vendorOnboardApprovalList.msaType}}</span>
                                </td>
                        
                                <td [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isMSATemplateAvailable')">
                                    <span
                                        *ngIf="(vendorOnboardApprovalList.msaTemplateContent != null)"><a
                                        [routerLink]="[]"
                                        (click)="viewDocumentTemplate(vendorOnboardApprovalList.msaTemplateContent,true)">Yes</a></span>
                                    <span
                                        *ngIf="(vendorOnboardApprovalList.msaTemplateContent === null)">No</span>
                                        <!-- <span
                                        *ngIf="(vendorOnboardApprovalList.msaTemplateContent != null && (vendorOnboardApprovalList.statusName === 'Submitted By Vendor' || vendorOnboardApprovalList.statusName === 'Vendor Onboarded'))">Yes</span> -->
                                </td>
                        
                                <td [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isPOTemplateAvailable')">
                                    <span
                                        *ngIf="( vendorOnboardApprovalList.poTemplateContent != null)"><a
                                            [routerLink]="[]"
                                            (click)="viewDocumentTemplate(vendorOnboardApprovalList.poTemplateContent,false)">Yes</a></span>
                                    <span
                                        *ngIf="( vendorOnboardApprovalList.poTemplateContent === null )">No</span>
                                        <!-- <span
                                        *ngIf="(vendorOnboardApprovalList.poTemplateContent != null && (vendorOnboardApprovalList.statusName === 'Submitted By Vendor' || vendorOnboardApprovalList.statusName === 'Vendor Onboarded'))">Yes</span> -->
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('isNCATemplateAvailable')">
                                    <span
                                        *ngIf="(vendorOnboardApprovalList.ncaTemplateContent != null)"><a
                                        [routerLink]="[]"
                                        (click)="viewDocumentTemplate(vendorOnboardApprovalList.ncaTemplateContent,false)">Yes</a></span>
                                    <span
                                        *ngIf="(vendorOnboardApprovalList.ncaTemplateContent === null)">No</span>
                                    <!-- <span
                                        *ngIf="(vendorOnboardApprovalList.ncaTemplateContent != null && (vendorOnboardApprovalList.statusName === 'Submitted By Vendor' || vendorOnboardApprovalList.statusName === 'Vendor Onboarded'))">Yes</span> -->
                                </td>

                                <td [ngStyle]="{'width':setColumnWidth(6)}" *ngIf="isShowColumns('insuranceExhibitId')">
                                    <!-- <span
                                        *ngIf="(vendorOnboardProcessList.isInsuranceExhibit != null)"><a
                                        [routerLink]="[]"
                                        (click)="viewDocumentTemplate(vendorOnboardProcessList.insuranceExhibit, false)">Yes</a></span>
                                    <span
                                        *ngIf="(vendorOnboardProcessList.insuranceExhibit === null)">No</span> -->
                                    <!-- <span
                                        *ngIf="(vendorOnboardProcessList.ncaTemplateContent != null && (vendorOnboardProcessList.statusName === 'Submitted By Vendor' || vendorOnboardProcessList.statusName === 'Vendor Onboarded'))">Yes</span> -->
                                        <a [routerLink]="[]" class="table-icon table-icon-menu" (click)="insuranceExhibitDownloadFile(vendorOnboardApprovalList.insuranceExhibitId)"><i class="pi pi-eye"></i></a>
                                    </td>
                                    <td [ngStyle]="{'width':setColumnWidth(7)}" *ngIf="isShowColumns('isEmailSent')">
                                        <!-- <span
                                            *ngIf="(vendorOnboardApprovalList.isEmailSent != null || vendorOnboardApprovalList.isEmailSent == true)">Yes</span>
                                        <span
                                            *ngIf="(vendorOnboardApprovalList.isEmailSent == null || vendorOnboardApprovalList.isEmailSent == false)">No</span> -->
                                            <span>{{vendorOnboardApprovalList.isEmailSent}}</span>

                                    </td>
                        
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdByName')">
                                    <span>{{vendorOnboardApprovalList.createdByName}}</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('createdOn')">
                                    <span>{{vendorOnboardApprovalList.createdOn |
                                        date:'MM/dd/yyyy'}}</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('submittedByEmail')">
                                    <span>{{vendorOnboardApprovalList.submittedByEmail}}</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('vendorSubmittedOn')">
                                    <span>{{vendorOnboardApprovalList.vendorSubmittedOn |
                                        date:'MM/dd/yyyy'}}</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedByName')">
                                    <span>{{vendorOnboardApprovalList.modifiedByName}}</span>
                                </td>
                                <td [ngStyle]="{'width':setColumnWidth(9)}" *ngIf="isShowColumns('modifiedOn')">
                                    <span>{{vendorOnboardApprovalList.modifiedOn |
                                        date:'MM/dd/yyyy'}}</span>
                                </td>
                                
                        
                        
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                             
                                <td [attr.colspan]="selectedColumns.length">No Vendor Onboard Approval Records found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-dialog [(visible)]="vendorOnboardApprovalHistoryModal" [modal]="true" class="vendor-onboard-approval-history-popup"
                        [modal]="true" [style]="{width: '70vw',height:'auto',top:'7px'}" [draggable]="false" [resizable]="false">
                        <p-header [style]="{height: '10vh',padding :'.5rm'}"> {{ vendorOnboardApprovalHistoryTitle }} </p-header>
                        <p-table [value]="vendorOnboardApprovalHistoryList" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5rem">Status</th>
                                    <th style="width: 15rem">Description</th>
                                    <th style="width: 6rem">Created By</th>
                                    <th style="width: 6rem">Created On</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-vendorOnboardApprovalHistoryList>
                                <tr>
                                    <td>
                                        <span class="customer-badge status-checklists-pending"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Pending Approval')">Pending
                                            Approval</span>
                                        <span class="customer-badge status-interview-completed"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Template Modified')">Template
                                            Modified</span>
                                        <span class="customer-badge status-not-selected"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Template Rejected')">Template
                                            Rejected</span>
                                        <span class="customer-badge status-submitted"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Template Approved')">Template
                                            Approved</span>
                                        <span class="customer-badge status-offer-accepted"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Email Initiated')">Email Initiated</span>
                                        <span class="customer-badge status-reviewed"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Email Resent')">Email Resent</span>
                                        <span class="customer-badge status-forwarded"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Submitted By Vendor')">Submitted By
                                            Vendor</span>
                                            <span class="customer-badge status-withdrawn-offer"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Submitted By Applicant')">Submitted By
                                            Applicant</span>
                                        <span class="customer-badge status-interview"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Vendor Onboarded')">Vendor
                                            Onboarded</span>
                                        <span class="customer-badge status-joined"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Vendor Link Reinitiated')">Vendor Link Reinitiated</span>
                                        <span class="customer-badge status-offer-accepted"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='NCA Link Reinitiated')">NCA Link Reinitiated</span>
                                            <span class="customer-badge status-interview"
                                            *ngIf="(vendorOnboardApprovalHistoryList.statusName==='Completed')">Completed</span>
                                    </td>
                                    <!-- <td>{{vendorOnboardApprovalHistoryList?.notes}}</td> -->
                                    <td style="overflow-wrap:break-word;" *ngIf="(vendorOnboardApprovalHistoryList?.notes != null)"><a
                                            [routerLink]=""
                                            (click)="viewVendorOnboardApprovalHistoryDescription(vendorOnboardApprovalHistoryList.notesToDisplay)">{{(vendorOnboardApprovalHistoryList?.notes
                                            | slice:0:100) + (vendorOnboardApprovalHistoryList?.notes.length > 100 ? '...' : '')}}</a></td>
                                    <td style="overflow-wrap:break-word;" *ngIf="(vendorOnboardApprovalHistoryList?.notes == null)"><a
                                            [routerLink]=""
                                            (click)="viewVendorOnboardApprovalHistoryDescription(vendorOnboardApprovalHistoryList.notesToDisplay)">{{vendorOnboardApprovalHistoryList?.notes
                                            }}</a></td>
                                    <td *ngIf="vendorOnboardApprovalHistoryList.statusName !='Submitted By Vendor' && vendorOnboardApprovalHistoryList.statusName !='Submitted By Applicant'" >
                                        {{vendorOnboardApprovalHistoryList?.createdByName }}
                                    </td>
                                    <td *ngIf="vendorOnboardApprovalHistoryList.statusName ==='Submitted By Vendor'" >
                                       <span>Submitted By Vendor</span>
                                    </td>
                                    <td *ngIf="vendorOnboardApprovalHistoryList.statusName ==='Submitted By Applicant'" >
                                        <span>Submitted By Applicant</span>
                                    </td>
                                    <td>
                                        {{vendorOnboardApprovalHistoryList?.createdOn | date:'MM/dd/yyyy hh:mm a'}}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-dialog>
                    <p-dialog header="Description" [(visible)]="vendorOnboardApprovalHistoryDescriptionModal" [modal]="true"
                        class="invoice-history-popup" [draggable]="false" [resizable]="false">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="p-text-normal">
                                    <div #vendorOnboardApprovalHistoryDescriptionContainer></div>
                                </div>
                            </div>
                        </div>
                    </p-dialog>
                      <p-dialog [(visible)]="isEmailLinkResendDialog" [closable]="false" [draggable]="false"  [modal]="true"
                      [baseZIndex]="10001">
                        <p-header *ngIf="!isC2CVendor" [style]="{height: '10vh',padding :'.5rm'}"> {{ emailLinkResendDialogTitleC2C }} </p-header>
                        <p-header *ngIf="isC2CVendor" [style]="{height: '10vh',padding :'.5rm'}"> {{ emailLinkResendDialogTitle1099 }} </p-header>
                        <div class="p-field p-col-12 p-md-1">                                
                        </div>
                        <form [formGroup]="emailLinkResendForm">
                                      
                        <div formArrayName="emailLinkResendEmailAdd" >
                        <div class="p-fluid p-formgrid p-grid " *ngFor="let addEmail of emailLinkResendForm.controls.emailLinkResendEmailAdd['controls']; let i=index;"
                        [formGroupName]="i">
                            <div class="p-field p-col-12 p-md-9">
                                <div class="p-text-bold" *ngIf="!isC2CVendor">Email ID<span class="required-field">*</span></div>
                                <div class="p-text-bold" *ngIf="isC2CVendor">Vendor Email ID<span class="required-field">*</span></div>
                                <div class="p-text-normal">
                                    <!-- <input type="text" #description formControlName="emailId" pInputText readonly disabled="true"> -->
                                    <input type="text" #description formControlName="emailId" pInputText  maxlength="100" >
                                    <span class="text-danger"
                                        *ngIf="(addEmail.controls.emailId.touched) && addEmail.controls.emailId.errors?.required">
                                      </span>
                                      <span class="text-danger"
                                        *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.email">
                                        Please enter a valid email address
                                      </span>
                                       <span class="text-danger"
                                        *ngIf="addEmail.controls.emailId.touched && addEmail.controls.emailId.errors?.pattern">
                                        Please enter a valid email address
                                      </span>
                                      <span class="text-danger" *ngIf="addEmail?.controls?.emailId?.hasError('emailInvalid')">
                                        Please enter a valid email address<br />
                                      </span>
                                </div>
                            </div>
                            <div class="p-field p-col-12 p-md-1">
                              <div class="p-d-flex p-jc-between">
                                  <div>
                                  <button pButton pRipple *ngIf="i!=0"   (click)="removeEmailFieldsEmailLinkResend(i)" type="button" icon="pi pi-minus"
                                      class="p-button-rounded p-button-danger ext-right" style="margin-right: 5px"></button>
                                  </div>
                                  <div>
                                      <button pButton pRipple   (click)="addEmailFieldsEmailLinkResend(i)" type="button" icon="pi pi-plus"
                                          class="p-button-rounded float-right"></button>
                                  </div>
                              </div>
                          </div>
                     
                            <div class="p-field p-col-12 p-md-1">
                                
                            </div>
                        </div>
                      </div>
                      <div class="p-fluid p-formgrid p-grid ">
                        <div class="p-field p-col-12 p-md-9">
                            <div class="p-text-bold">Link Validity<span class="required-field">*</span></div>
                            <div class="p-text-normal">
                                <p-dropdown formControlName="emailLinkValidityHoursId" (onChange)="getEmailLinkValidityHoursOnChange($event)" [options]="allEmailLinkValidityHours"
                                placeholder="Select" optionLabel="description" >
                            </p-dropdown></div>
                        </div>
                        <div class="p-field p-col-12 p-md-1">
                                    
                        </div>
                      </div>
                     
                      <!-- <div class="p-fluid p-formgrid p-grid " *ngIf="isC2CVendor">
                        <div class="p-field p-col-12 p-md-9" >
                          <div class="p-text-bold">Applicant Email Id<span class="required-field">*</span></div>
                        
                        <div class="p-text-normal">
                          <input type="text" #description formControlName="applicantEmailId" pInputText  maxlength="100" >
                          <span class="text-danger"
                          *ngIf="(vendorOnboardProcessApproveFormControl?.controls?.applicantEmailId?.touched) && vendorOnboardProcessApproveFormControl?.applicantEmailId?.errors?.required">
                        </span>
                        <span class="text-danger" *ngIf="vendorOnboardProcessApproveFormControl?.controls?.applicantEmailId?.hasError('emailInvalid')">
                          Please Enter a Valid Email Address<br />
                        </span>
                        </div>
                        </div>
                    </div> -->
                      <!-- <div class="p-field p-col-12 p-md-1">
                        <div class="p-text-bold">Comments</div>
                      </div> -->
                        <div class="card p-m-2 p-p-2">
                            <div class="p-text-bold">Comments</div>
                            <!-- <textarea [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize"></textarea> -->
                            <!-- <textarea id="invoiceRejectReason" [(ngModel)]= "invoiceRejectReason" name="invoiceRejectReasonvalidate" required #invoiceRejectReasonvalidate="ngModel" [rows]="5" pInputTextarea style="width: 100%;"></textarea> -->
                            <quill-editor [modules]="vendorOnboardApprovalCommentsModules" formControlName="comments" placeholder=""
                                ></quill-editor>
                            <span class="text-danger" *ngIf="emailLinkResendForm.controls.comments.hasError('maxlengthError')">
                                Only 10000 characters allowed.
                            </span>
                      
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-right p-mt-2">
                            <p-button  icon="pi pi-times" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-danger p-mr-2" (click)="onCancelEmailLinkResend()" pRipple type="button"
                                label="Cancel" class="p-button-sm p-button-info p-ai-center"></p-button>&nbsp;&nbsp;&nbsp;
                            <p-button icon="pi pi-check" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-success p-mr-2" [disabled]="!emailLinkResendForm.valid"
                                (onClick)="submitEmailLinkResend(emailLinkResendForm)" pRipple type="button" label="Resend Link" [loading]="loadingSaveButton"
                                class="p-button-sm p-button-info p-ai-center"></p-button>
                        </div>
                      </form>
                      </p-dialog>

                      <p-dialog [(visible)]="isEmailLinkResendNCADialog" [closable]="false" [draggable]="false"  [modal]="true"
                      [baseZIndex]="10001">
                        <p-header [style]="{height: '10vh',padding :'.5rm'}"> {{ emailLinkResendDialogTitleNCA }} </p-header>
                        <div class="p-field p-col-12 p-md-1">                                
                        </div>
                        <form [formGroup]="emailLinkResendNCAForm">
                            <div class="p-fluid p-formgrid p-grid ">
                        <div class="p-field p-col-12 p-md-9" >
                          <div class="p-text-bold">Applicant Email Id<span class="required-field">*</span></div>
                        
                        <!-- <div class="p-text-normal">
                          <input type="text" #description formControlName="applicantEmailId" pInputText  maxlength="100" >
                          <span class="text-danger"
                          *ngIf="(emailLinkResendNCAFormControl?.controls?.applicantEmailId?.touched) && emailLinkResendNCAFormControl?.applicantEmailId?.errors?.required">
                        </span>
                        <span class="text-danger" *ngIf="emailLinkResendNCAFormControl?.controls?.applicantEmailId?.hasError('emailInvalid')">
                          Please Enter a Valid Email Address<br />
                        </span>
                        </div> -->
                        <div class="p-text-normal">
                            <input type="text" #description formControlName="applicantEmailId" pInputText  maxlength="100" >
                            <span class="text-danger"
                                *ngIf="(emailLinkResendNCAFormControl?.applicantEmailId?.touched) && emailLinkResendNCAFormControl?.applicantEmailId?.errors?.required">
                                Please enter a email address
                            </span>
                              <span class="text-danger"
                                *ngIf="emailLinkResendNCAFormControl?.applicantEmailId?.touched && emailLinkResendNCAFormControl?.applicantEmailId?.errors?.email">
                                Please enter a valid email address
                              </span>
                               <span class="text-danger"
                                *ngIf="emailLinkResendNCAFormControl?.applicantEmailId?.touched && emailLinkResendNCAFormControl?.applicantEmailId?.errors?.pattern">
                                Please enter a valid email address
                              </span>
                              <span class="text-danger" *ngIf="emailLinkResendNCAFormControl?.applicantEmailId?.emailId?.hasError('emailInvalid')">
                                Please enter a valid email address<br />
                              </span>
                        </div>
                        </div>
                    </div>
                       
                      <div class="p-fluid p-formgrid p-grid ">
                        <div class="p-field p-col-12 p-md-9">
                            <div class="p-text-bold">Link Validity<span class="required-field">*</span></div>
                            <div class="p-text-normal">
                                <p-dropdown formControlName="emailLinkValidityHoursId" (onChange)="getEmailLinkValidityHoursOnChange($event)" [options]="allEmailLinkValidityHours"
                                placeholder="Select" optionLabel="description" >
                            </p-dropdown></div>
                        </div>
                        <div class="p-field p-col-12 p-md-1">
                                    
                        </div>
                      </div>
                     
                   
                        <div class="card p-m-2 p-p-2">
                            <div class="p-text-bold">Comments</div>
                            <!-- <textarea [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize"></textarea> -->
                            <!-- <textarea id="invoiceRejectReason" [(ngModel)]= "invoiceRejectReason" name="invoiceRejectReasonvalidate" required #invoiceRejectReasonvalidate="ngModel" [rows]="5" pInputTextarea style="width: 100%;"></textarea> -->
                            <quill-editor [modules]="vendorOnboardApprovalCommentsModules" formControlName="comments" placeholder=""
                                ></quill-editor>
                            <span class="text-danger" *ngIf="emailLinkResendNCAForm.controls.comments.hasError('maxlengthError')">
                                Only 10000 characters allowed.
                            </span>
                      
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-right p-mt-2">
                            <p-button  icon="pi pi-times" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-danger p-mr-2" (click)="onCancelEmailLinkResendNCA()" pRipple type="button"
                                label="Cancel" class="p-button-sm p-button-info p-ai-center"></p-button>&nbsp;&nbsp;&nbsp;
                            <p-button icon="pi pi-check" [ngStyle]="{'height.px': 30 }" styleClass=" p-button-success p-mr-2" [disabled]="!emailLinkResendNCAForm.valid"
                                (onClick)="submitEmailLinkResendNCA(emailLinkResendNCAForm)" pRipple type="button" label="Resend Link" [loading]="loadingSaveButton"
                                class="p-button-sm p-button-info p-ai-center"></p-button>
                        </div>
                      </form>
                      </p-dialog>

                      <p-dialog header="Template Preview" [(visible)]="viewDocumentTemplateModal" [modal]="true" class="vendor-onboard-approval-history-popup"
                    [draggable]="false" [resizable]="false" [baseZIndex]="10000">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="p-text-normal">
                              <br>
                              <div class="card pdftop">
                              <div class="row">
                                <div class="col-md-6">
                                    <br>
                                    <img class="logo" [src]="logoOnMSALeft" width="160px" style="margin-left: 28px;">
                                </div>
                                <div class="col-md-6 text-right">
                                    <br>
                                    <img class="logo" [src]="logoOnMSARight" width="270px" style="margin-right: 28px;">
                                </div>
                                
                              </div>
                              <div class="container">  
                                <div class="pdfcontent" style="text-align: justify;" #previewDocumentTemplate></div>
                              </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    </p-dialog>
                      <p-toast [baseZIndex]="100001" position="bottom-center"></p-toast>

                </div>
            </div>
            <!-- <br>
            <br>
            <br>
            <br> -->
        </div>
    </div>

</section>